<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>修改价格设置</b>
    </a-divider>

    <a-spin :spinning="loading">
      <div v-if="pointGoods">
        <!-- 商品基本信息展示 -->
        <a-card :bordered="true" style="margin-bottom: 20px;">
          <a-row :gutter="16">
            <a-col :span="6">
              <img v-if="pointGoods.picture" :src="pointGoods.picture" style="width: 120px; height: 120px; object-fit: cover; border-radius: 4px;" />
              <div v-else style="width: 120px; height: 120px; background: #f0f0f0; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
                <span style="color: #999;">暂无图片</span>
              </div>
            </a-col>
            <a-col :span="18">
              <a-descriptions :column="2" bordered size="small">
                <a-descriptions-item label="商品名称" :span="2">{{ pointGoods.goodsName || '-' }}</a-descriptions-item>
                <a-descriptions-item label="商品编号">{{ pointGoods.goodsCode || '-' }}</a-descriptions-item>
                <a-descriptions-item label="市场价">¥{{ pointGoods.marketPrice || 0 }}</a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
        </a-card>

        <!-- SKU价格设置 -->
        <a-alert message="请修改各SKU的现金价和积分价格,现金价和积分价格必须大于0" type="info" show-icon style="margin-bottom: 16px;" />
        <a-table
          :loading="skuLoading"
          rowKey="id"
          :size="tableSize"
          :columns="skuColumns"
          :data-source="skuList"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <img v-if="record.picture" :src="record.picture" style="width: 50px; height: 50px; object-fit: cover; cursor: pointer;" @click="handlePreview(record.picture)" alt="SKU图片" />
            <div v-else style="width: 50px; height: 50px; background: #f0f0f0; border-radius: 4px;"></div>
          </template>
          <template slot="price" slot-scope="text, record">
            <a-input-number
              v-model="record.price"
              :min="0.00"
              :max="2147483647"
              :precision="2"
              placeholder="现金价"
              style="width: 100%"
            />
          </template>
          <template slot="pointPrice" slot-scope="text, record">
            <a-input-number
              v-model="record.pointPrice"
              :min="0"
              :max="2147483647"
              :precision="0"
              placeholder="积分价"
              style="width: 100%"
            />
          </template>
          <template slot="stock" slot-scope="text, record">
            <a-tag :color="record.stock > 0 ? 'green' : 'red'">
              {{ record.stock || 0 }}
            </a-tag>
          </template>
        </a-table>
      </div>
    </a-spin>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="preview" style="width: 100%" :src="previewImage" />
    </a-modal>

    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">
          保存
        </a-button>
        <a-button @click="onClose">
          取消
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getGoods, editPointPrice, getSkuListByPointGoodsId } from '@/api/goodspoint/goodspoint'
import { mapGetters } from 'vuex'

export default {
  name: 'EditForm',
  components: {},
  data() {
    return {
      loading: false,
      skuLoading: false,
      submitLoading: false,
      open: false,
      pointGoodsId: null,
      pointGoods: null,
      skuList: [],
      previewVisible: false,
      previewImage: '',
      skuColumns: [
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 150,
          ellipsis: true
        },
        {
          title: 'SKU图片',
          dataIndex: 'picture',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '现金价(元)',
          dataIndex: 'price',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '积分价',
          dataIndex: 'pointPrice',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'pointPrice' }
        },
        {
          title: '库存',
          dataIndex: 'stock',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'stock' }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['tableSize', 'tableBordered'])
  },
  methods: {
    handlePreview(url) {
      this.previewImage = url
      this.previewVisible = true
    },
    onClose() {
      this.open = false
      this.reset()
    },
    reset() {
      this.pointGoodsId = null
      this.pointGoods = null
      this.skuList = []
      this.submitLoading = false
    },
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      this.pointGoodsId = id
      this.open = true

      this.loading = true
      this.skuLoading = true

      Promise.all([
        getGoods({ id }),
        getSkuListByPointGoodsId(id)
      ]).then(([goodsRes, skuRes]) => {
        this.pointGoods = goodsRes.data
        this.skuList = (skuRes.data || []).map(sku => ({
          id: sku.id,
          skuId: sku.id,
          skuName: sku.skuName || '',
          picture: sku.picture || '',
          price: sku.price || 0,
          stock: sku.stock || 0,
          pointPrice: sku.pointPrice || null
        }))
      }).catch(error => {
        console.error('加载积分商品信息失败:', error)
        this.$message.error('加载商品信息失败')
      }).finally(() => {
        this.loading = false
        this.skuLoading = false
      })
    },
    submitForm() {
      if (!this.skuList || this.skuList.length === 0) {
        this.$message.warning('SKU列表不能为空')
        return
      }

      // 验证价格设置
      for (let i = 0; i < this.skuList.length; i++) {
        const sku = this.skuList[i]
        console.log('sku:', sku)
        // if (!sku.price || sku.price < 0.00) {
        //   this.$message.warning(`SKU [${sku.skuName}] 的现金价必须大于0`)
        //   return
        // }
        if (sku.pointPrice < 0) {
          this.$message.warning(`SKU [${sku.skuName}] 的积分价不能小于0`)
          return
        }
      }

      // 检查是否所有价格都为0(不能现金价和积分价同时为0)
      const allZero = this.skuList.every(sku => sku.price === 0 && (sku.pointPrice === 0 || sku.pointPrice === null))
      if (allZero) {
        this.$message.warning('现金价和积分价不能同时为0,至少需要设置一种价格')
        return
      }

      this.submitLoading = true
      const editData = {
        pointGoodsId: this.pointGoodsId,
        skuPointPrices: this.skuList.map(sku => ({
          skuId: sku.id,
          price: sku.price,
          pointPrice: sku.pointPrice
        }))
      }

      editPointPrice(editData).then(() => {
        this.$message.success('修改成功')
        this.open = false
        this.$emit('ok')
      }).catch(error => {
        console.error('修改价格失败:', error)
        this.$message.error(error.message || '修改失败')
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  text-align: right;
}
</style>
